// extracted by mini-css-extract-plugin
export default {"root":"classes_root__EkwSt","button-container":"classes_button-container__GusYS","sign-container":"classes_sign-container__YCsrt","trash-icon":"classes_trash-icon__FFFv2"};